import { QueovalBase, QueovalDate, QueovalDik } from '../global/class.global';
import { Select } from '../utilities';


export class AffecteTempsModel extends QueovalBase {
  public ListLigneTemps: Array<LigneAffecteTemps>;
  public LigneTemps: LigneAffecteTemps;
  public FiltreTemps: FiltreAffecteTemps;


  constructor() {
    super();
    this.ListLigneTemps = new Array<LigneAffecteTemps>();
    this.FiltreTemps = new FiltreAffecteTemps();
    this.LigneTemps = new LigneAffecteTemps();

  }
}


export class LigneAffecteTemps {

  public Ident: string;
  public Date: QueovalDate;

  public Client: Select;
  public Mission: AffecteTempsMission;
  public Millesime: Select;
  public Activite: Select;
  public Rdv: Select;

  public Libelle: string;
  public Temps: string;
  public CumulTemps: string;
  
  public Article: Select;
  public ArticleDisabled: boolean;
  public Quantite: string;

  public Edit: boolean;
  public Loading: boolean;
  constructor() {
    this.Client = new Select();
    this.Mission = new AffecteTempsMission();
    this.Millesime = new Select();
    this.Activite = new Select();
    this.Article = new Select();

    this.Rdv = new Select();

  }
}


export class AffecteTempsMission extends Select {
  public IsProjet: boolean;
  public IsPrestation: boolean;
  public IsCloturee: boolean;
  public CloturerPrestation: boolean;
  constructor() {
    super();
    this.IsCloturee = false;
    this.CloturerPrestation = false;
  }
}

export class FiltreAffecteTemps {

  public IdCollabo: string;
  public PrestaCheck: boolean;
  public ProjetCheck: boolean;
  public DateDebut: QueovalDate;
  public DateFin: QueovalDate;
  public IsFacturationArticle: boolean;

  public ListMission: Array<AffecteTempsMission>;
  public ListMillesime: Array<Select>;
  public ListActivite: Array<Select>;
  public ListArticle: Array<Select>;

  public ListObligation: Array<QueovalDik>;

  public FiltreAffecteTemps() {
    this.ListMission = new Array<AffecteTempsMission>();
    this.ListMillesime = new Array<Select>();
    this.ListActivite = new Array<Select>();
    this.ListActivite = new Array<Select>();
    this.ListObligation = new Array<QueovalDik>();
  }
}
